<template>
  <div class="container-single-5emo" v-if="items" :style="{'flex-wrap': wrap ? 'wrap' : 'nowrap', 'width': wrap ? '75%' : '100%'}">
    <div v-for="item in items" :key="item.class"
      :style="{'margin-bottom': wrap ? '10px' : '0', 'width': wrap ? '8.5rem' : '', 'height': wrap ? '7rem' : ''}"
      class="button-single-5emo"
      :class="`btn-${item.label} is-${questionId}`"
      @click="selectOption(item.color, `btn-${item.label}`, item.rating, $t(item.label))">
      <i :class="`image-icon ${item.icon}`" :style="{'color': item.color }"></i>
      <p class="text-default" :style="{'color': textColor }">{{ $t(item.label) }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Single5emo',
  status: 'prototype',
  release: '1.0.0',
  props: {
    questionType: {
      type: String
    },
    questionId: {
      type: String
    },
    textColor: {
      type: String,
      default: '#242424'
    },
    wrap: {
      type: Boolean,
      default: false
    },
    rating: {
      type: String
    }
  },
  data () {
    return {
      items: null,
      labels: null
    }
  },
  mounted () {
    const itemCsat = [
      { label: 'vs', icon: 'icon-joy-gee', color: '#49BB59', rating: 100 },
      { label: 'sat', icon: 'icon-happy-gee', color: '#37B0E4', rating: 75 },
      { label: 'ind', icon: 'icon-neutral-sleep', color: '#9E9E9E', rating: 50 },
      { label: 'un', icon: 'icon-unhappy-sleep', color: '#F26C3C', rating: 25 },
      { label: 'vu', icon: 'icon-wow-open', color: '#EE2E35', rating: 0 }
    ]

    const itemKpi = [
      { label: 'ex', icon: 'icon-joy-gee', color: '#49BB59', rating: 100 },
      { label: 'vg', icon: 'icon-happy-gee', color: '#37B0E4', rating: 75 },
      { label: 'satisf', icon: 'icon-neutral-sleep', color: '#9E9E9E', rating: 50 },
      { label: 'bd', icon: 'icon-unhappy-sleep', color: '#F26C3C', rating: 25 },
      { label: 'vb', icon: 'icon-wow-open', color: '#EE2E35', rating: 0 }
    ]

    this.items = this.questionType === 'csat' ? itemCsat : itemKpi

    const responseOnLoad = this.items.find(e => e.rating.toString() === this.rating)

    if (responseOnLoad) {
      setTimeout(() => {
        this.selectOption(responseOnLoad.color, `btn-${responseOnLoad.label}`, responseOnLoad.rating, this.$t(responseOnLoad.label))
      }, 10)
    }
  },
  methods: {
    selectOption (color, classInput, value, label) {
      const valueToSend = { rating: value, value: label }
      const buttons = document.querySelectorAll(`.is-${this.questionId}`)

      for (const child of buttons) {
        child.style.borderColor = '#b1b1b1'
        child.style.transform = 'scale(1)'
        child.style.boxShadow = 'none'
      }

      const buttonSelected = document.querySelector(`.${classInput}`)

      buttonSelected.style.borderColor = `${color}80`
      buttonSelected.style.transform = 'scale(1.020)'
      buttonSelected.style.boxShadow = `0px 0px 5px 2px ${color}50`

      return this.$emit('isValue', valueToSend)
    }
  }
}
</script>

<style lang="scss" scoped>
:root {
  font-size: 62.5%;
}

@import "../../styles/styles.scss";
@font-face {
  font-family: "icomoon";
  src: url("../../assets/fonts/icomoon.eot?-bkw6sq");
  src: url("../../assets/fonts/icomoon.eot?#iefix-bkw6sq") format("embedded-opentype"),
    url("../../assets/fonts/icomoon.woff?-bkw6sq") format("woff"),
    url("../../assets/fonts/icomoon.ttf?-bkw6sq") format("truetype"),
    url("../../assets/fonts/icomoon.svg?-bkw6sq#icomoon") format("svg");
  font-weight: normal;
  font-style: normal;
}

.icon-happy-gee:before {
  content: "\e600";
}
.icon-happy-sleep:before {
  content: "\e601";
}
.icon-happy-wink:before {
  content: "\e602";
}
.icon-joy-gee:before {
  content: "\e603";
}
.icon-joy-open:before {
  content: "\e604";
}
.icon-joy-sleep:before {
  content: "\e605";
}
.icon-neutral-sleep:before {
  content: "\e606";
}
.icon-unhappy-sleep:before {
  content: "\e607";
}
.icon-wow-open:before {
  content: "\e608";
}

[class^="icon-"],
[class*=" icon-"] {
  font-family: "icomoon";
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.container-single-5emo {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  .button-single-5emo {
    width: 11rem;
    height: 9rem;
    margin: 0 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    border-radius: 1.5rem;
    border: 0.11rem solid #b1b1b1;
    cursor: pointer;
    .image-icon {
      font-size: 3rem;
    }
    .text-default {
      text-align: center;
      margin: 0;
      font-weight: bold;
      font-family: "Open Sans", Helvetica, Arial, sans-serif;
    }
  }
  .button-single-5emo:hover {
    transform: scale(1.020);
    filter: blur(0);
  }
}

@media only screen and (max-width: 500px) {
  .container-single-5emo {
    display: flex;
    justify-content: center;
    .button-single-5emo {
      width: 7.5rem;
      height: 6rem;
      border-radius: 1rem;
      margin: 0 0.3rem;
      .image-icon {
        font-size: 2.5rem;
      }
      .text-default {
        font-size: 1rem;
      }
    }
  }
}
</style>
